var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 1427,
    viewBox: "0 0 1500 1427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_138_859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1046.5,
    cy: 380.5,
    rx: 203.5,
    ry: 203.5,
    transform: "rotate(-180 1046.5 380.5)",
    fill: "#00C2FF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 453.5,
    cy: 973.5,
    rx: 203.5,
    ry: 203.5,
    transform: "rotate(-180 453.5 973.5)",
    fill: "#00C2FF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.5,
    cy: 315.5,
    r: 138.5,
    transform: "rotate(-180 390.5 315.5)",
    fill: "#FF1E98",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1111.5,
    cy: 1038.5,
    r: 138.5,
    transform: "rotate(-180 1111.5 1038.5)",
    fill: "#FF1E98",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_138_859",
    x: 0,
    y: -73.0001,
    width: 1500,
    height: 1500,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_138_859"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLights);
export default __webpack_public_path__ + "static/media/lights.b02199b3d04aa223f2f1218a985a7a4c.svg";
export { ForwardRef as ReactComponent };